import { Component } from "@kluntje/core";
import { removeEvent } from "@kluntje/js-utils/lib/dom-helpers";
import { ViewportObserver } from "@kluntje/services";

import IconShadowScss from "./fra-e-icon.shadow.scss";

class FRAIcon extends Component {
  viewportObserver = ViewportObserver.getInstance();

  constructor() {
    super({
      events: [
        {
          event: "kl-in-vp",
          target: "this",
          handler: "handleIntersectionChange",
        },
      ],
      props: {
        iconId: {
          type: "string",
          defaultValue: "",
        },
      },
      initialStates: {
        loaded: false,
      },
      useShadowDOM: true,
    });
  }
  static get observedAttributes(): string[] {
    return ["icon-id"];
  }
  /**
   * Handles Intersection Change, by removing viewportObserver
   * and initializing ImageLoad
   */
  handleIntersectionChange(): void {
    this.viewportObserver.unobserve(this);
    removeEvent(this, "kl-in-vp", this.handleIntersectionChange, this);
    if (!this.state.loaded) {
      this.loadIcon();
    }
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (oldValue === newValue) return;
    if (name === "icon-id") {
      this.loadIcon();
    }
  }

  get iconId(): string {
    return this.getAttribute("icon-id") || "";
  }

  afterComponentRender(): void {
    this.viewportObserver.observe(this);
  }

  async loadIcon() {
    const theIcon = await import(
      /* webpackChunkName: "fra-icon-" */
      `Icons/${this.iconId}.svg`
    )
      .then(({ default: icon }) => {
        return icon;
      })
      .catch(error => {
        console.warn(`An error occurred while loading the component: ${error}`);
        return "";
      });
    this.getUiRoot().innerHTML = `<style>${IconShadowScss}</style><span class="fra-e-icon__icon">${theIcon}</span>`;
    this.setState({ loaded: true });
  }
}

customElements.define("fra-e-icon", FRAIcon);
